import { VerifiedBadge } from "@/components/ui/VerifiedBadge";
import { cn } from "@/lib/utils";

export type MetricsSource = "certified" | "live" | "fixture" | "unverified";

/** Trust badge for protocol metrics — Certified ≠ admin approval. */
export function MetricsSourceBadge({
	source,
	className,
}: {
	source: MetricsSource | undefined;
	className?: string;
}) {
	if (!source) return null;
	if (source === "certified") {
		return <VerifiedBadge verified className={className} />;
	}
	if (source === "live") {
		return (
			<span
				className={cn(
					"inline-flex items-center rounded-full border border-border px-2 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-wider text-muted-foreground",
					className,
				)}
			>
				Live
			</span>
		);
	}
	if (source === "fixture") {
		return (
			<span
				className={cn(
					"inline-flex items-center rounded-full border border-border px-2 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-wider text-muted-foreground",
					className,
				)}
			>
				Unavailable
			</span>
		);
	}
	return <VerifiedBadge verified={false} className={className} />;
}
